import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from "react";
import AiTagItem from "./AiTagItem";
import classNames from "classnames";
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
var AddCustomFilterTag = function AddCustomFilterTag(_ref) {
  var result = _ref.result,
    customFields = _ref.customFields,
    filtersData = _ref.filtersData,
    setFiltersData = _ref.setFiltersData,
    applyFilters = _ref.applyFilters;
  var lastAssitantMessageId = useStoreState(Store, function (s) {
    return s.lastAssitantMessageId;
  });
  var _useState = useState(lastAssitantMessageId !== (result === null || result === void 0 ? void 0 : result.assistantIdentifier)),
    isDisabled = _useState[0],
    setIsDisabled = _useState[1];
  var _useState2 = useState({
      response: null,
      logic: "exact"
    }),
    editedValue = _useState2[0],
    setEditedValue = _useState2[1];
  useEffect(function () {
    setIsDisabled(lastAssitantMessageId !== (result === null || result === void 0 ? void 0 : result.assistantIdentifier));
  }, [lastAssitantMessageId, result === null || result === void 0 ? void 0 : result.assistantIdentifier]);
  var _useState3 = useState(result === null || result === void 0 ? void 0 : result.selectedTags),
    filterTags = _useState3[0],
    setFilterTags = _useState3[1];
  var _useState4 = useState(null),
    editingTag = _useState4[0],
    setEditingTag = _useState4[1];
  var onChangeField = function onChangeField(_filtersData, field, _value) {
    var logic = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "exact";
    var fieldId = field.id;
    var tagType = field.tag_type;
    var _customFields = _filtersData === null || _filtersData === void 0 ? void 0 : _filtersData.custom_tags;
    if (tagType === "integer") {
      _value = _value ? parseInt(_value, 10) : null;
    } else if (tagType === "float") {
      _value = _value ? parseFloat(_value) : null;
    } else if (tagType === "string") {
      logic = "exact";
    } else if (tagType === "multi_dropdown") {
      _value = _value.map(function (option) {
        return option.trim();
      });
      logic = "contains";
    } else if (tagType === "user") {
      _value = _value;
      logic = "exact";
    } else if (tagType === "boolean") {
      if (_value === "") {
        _value = null;
      } else if (typeof _value === "string") {
        _value = _value === "true";
      } else {
        _value = !!_value;
      }
      logic = "exact";
    } else if (tagType === "date") {
      // Handle both single dates and date arrays (for "between" logic)
      if (Array.isArray(_value)) {
        // For "between" logic, keep the array as-is, conversion will happen later
        _value = _value;
      } else {
        // For single dates, convert to ISO string
        _value = _value ? new Date(_value).toISOString() : null;
      }
    } else if (tagType === "datetime") {
      logic = "eq";
    } else if (tagType === "single_dropdown") {
      logic = "exact";
    }

    // Only add to payload if value is not null/undefined/empty
    if (_value != null && _value !== "") {
      var payload = {
        tag_id: fieldId,
        value: _value,
        logic: logic
      };
      var _customFieldIndex = _customFields === null || _customFields === void 0 ? void 0 : _customFields.findIndex(function (field) {
        return field.tag_id === fieldId;
      });
      if (_customFieldIndex !== -1) {
        _customFields[_customFieldIndex] = payload;
      } else {
        _customFields.push(payload);
      }
    } else {
      // Remove the field if value is null/undefined/empty
      var _customFieldIndex2 = _customFields === null || _customFields === void 0 ? void 0 : _customFields.findIndex(function (field) {
        return field.tag_id === fieldId;
      });
      if (_customFieldIndex2 !== -1) {
        _customFields === null || _customFields === void 0 || _customFields.splice(_customFieldIndex2, 1);
      }
    }
  };
  var _onEdit = function onEdit(tag) {
    setEditingTag(tag);
    setEditedValue({
      response: tag === null || tag === void 0 ? void 0 : tag.response,
      logic: tag.logic ? tag.logic : "exact"
    });
  };
  var _onSave = function onSave(tag) {
    if (editedValue) {
      setFilterTags(filterTags.map(function (t) {
        return t.tag_id === tag.tag_id ? _objectSpread(_objectSpread({}, t), {}, {
          response: editedValue === null || editedValue === void 0 ? void 0 : editedValue.response,
          logic: editedValue === null || editedValue === void 0 ? void 0 : editedValue.logic
        }) : t;
      }));
    }
    setEditingTag(null);
  };
  var _onCancel = function onCancel(tag) {
    setEditingTag(null);
  };
  var _onRemove = function onRemove(tag) {
    setFilterTags(filterTags.filter(function (t) {
      return t.tag_id !== tag.tag_id;
    }));
  };
  var _onValueChange = function onValueChange(tag, value) {
    setEditedValue(_objectSpread(_objectSpread({}, editedValue), {}, {
      response: value
    }));
  };
  var handleSaveAll = function handleSaveAll() {
    var _filtersData = _objectSpread({}, filtersData);
    var _customFields = _filtersData === null || _filtersData === void 0 ? void 0 : _filtersData.custom_tags;
    filterTags.forEach(function (tag) {
      onChangeField(_filtersData, tag.field, tag.response, tag.logic);
    });
    _customFields.forEach(function (field) {
      var logic = field === null || field === void 0 ? void 0 : field.logic;
      if (logic === "between") {
        var value = field === null || field === void 0 ? void 0 : field.value;
        if (Array.isArray(value) && value.length === 2) {
          field.value = new Date(value[0]).toISOString();
          field.logic = "gte";
          var newField = _objectSpread({}, field);
          newField.value = new Date(value[1]).toISOString();
          newField.logic = "lte";
          _customFields.push(newField);
        }
      }
    });
    setFiltersData(_filtersData);
    applyFilters(_filtersData);
    setIsDisabled(true);
  };
  var handleLogicChange = function handleLogicChange(logic) {
    if (editingTag) {
      setEditedValue(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          logic: logic
        });
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("dark:text-gray-200 flex justify-center", {
      "pointer-events-none opacity-50": isDisabled
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full max-w-4xl border dark:border-gray-800 border-gray-300 rounded-b-xl shadow-lg dark:bg-gray-800 bg-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mb-2 px-6 py-4 rounded-t-xl dark:bg-gray-800 bg-gray-100 border-b dark:border-gray-700"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-xl font-semibold text-white dark:text-white"
  }, "Filter by Tags")), filterTags.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "bg-white dark:bg-gray-900 rounded-b-xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap gap-3 px-6 py-4"
  }, filterTags === null || filterTags === void 0 ? void 0 : filterTags.map(function (tag) {
    var field = customFields === null || customFields === void 0 ? void 0 : customFields.find(function (f) {
      return f.id === Number(tag.tag_id);
    });
    // if (!field || !field?.additional?.isEnabled) return null;

    return /*#__PURE__*/React.createElement(AiTagItem, {
      key: field === null || field === void 0 ? void 0 : field.id,
      field: field,
      value: (editingTag === null || editingTag === void 0 ? void 0 : editingTag.tag_id) === tag.tag_id ? editedValue === null || editedValue === void 0 ? void 0 : editedValue.response : tag.response,
      isEditing: (editingTag === null || editingTag === void 0 ? void 0 : editingTag.tag_id) === tag.tag_id,
      onEdit: function onEdit() {
        return _onEdit(tag);
      },
      onSave: function onSave() {
        return _onSave(tag);
      },
      onCancel: function onCancel() {
        return _onCancel(tag);
      },
      onValueChange: function onValueChange(value) {
        return _onValueChange(tag, value);
      },
      onRemove: function onRemove() {
        return _onRemove(tag);
      },
      showLogic: true,
      onLogicChange: function onLogicChange(logic) {
        return handleLogicChange(logic);
      },
      logic: (editingTag === null || editingTag === void 0 ? void 0 : editingTag.tag_id) === tag.tag_id ? editedValue.logic : tag.logic
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex  px-6 pb-5"
  }, /*#__PURE__*/React.createElement("button", {
    className: "bg-teal-500 hover:bg-teal-600 text-white font-medium px-5 py-2 rounded-lg transition-colors shadow-sm",
    onClick: function onClick() {
      return handleSaveAll();
    }
  }, "Apply"))), filterTags.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "bg-white dark:bg-gray-900 rounded-b-xl"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap gap-3 px-6 py-4"
  }, /*#__PURE__*/React.createElement("p", null, "No tags found")))));
};
export default AddCustomFilterTag;